<template>
    <v-row>
        <v-col cols="4">
            <v-switch v-model="model.active" :label="notification.eventName" :false-value="false" />
        </v-col>
        <v-col cols="4" class="d-flex">
            <v-col>
                <v-checkbox v-model="model.channel" value="mail" label="By mail" />
            </v-col>
            <v-col>
                <v-checkbox v-model="model.channel" value="database" label="In App" />
            </v-col>
        </v-col>
        <v-col cols="4" v-if="notification.shop" class="d-flex">
            <v-col v-for="shop in shops" :key="'_shop_'+shop.id">
                <v-checkbox v-model="model.selectedShops[shop.id]" :label="shop.name" />
            </v-col>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        notification: {
            type: Object,
            required: true
        },
    },
    data: () => ({
        initiate: false,
        model: {
            active: false,
            selectedShops:{},
            channel:[]
        }
    }),
    watch: {
        model: {
            deep: true,
            handler (v) {
                if(this.initiate) {
                    if(v.active){
                        this.subscribe(this.model)
                    }else{
                        this.unsubscribe(this.model)
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters('shops', ['shops'])
    },
    mounted () {
        this.model.event = this.notification.event
        if(this.notification.userPrefs.length > 0){
            this.model.active = true
        }
        for (let idx = 0; idx < this.notification.userPrefs.length; idx++) {
            const pref = this.notification.userPrefs[idx];
            if(!this.model.channel.includes(pref.channel)){
                this.model.channel.push(pref.channel)
            }
            if(!this.model.selectedShops[pref.shop_id]){
                this.model.selectedShops[pref.shop_id] = true
            }
        }
        this.initiate = true
    },
    methods: {
        ...mapActions('notifications', ['subscribe', 'unsubscribe'])
    }
}
</script>

<style>

</style>